module.exports = __webpack_public_path__ + "img/logo.aaa0bf16.png";